/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createCart} from '../api'

export const useMutationCreateCart = createReactQueryMutationHook('createCart', createCart)
